module.exports = __webpack_public_path__ + "static/img/vFive4.030df15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vFive4.png
// module id = HC3y
// module chunks = 2